import React from 'react';
import ReactDOM from 'react-dom/client';
import { Router, Route, Switch } from 'wouter';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import './index.css';
import './lib/i18n';

// Pages
import Login from './pages/Login';
import Callback from './pages/Callback';
import Dashboard from './pages/Dashboard';

// Admin Pages
import AdminLogin from './pages/admin/AdminLogin';
import AdminDashboard from './pages/admin/AdminDashboard';
import ConversationView from './pages/admin/ConversationView';
import AnalyticsView from './pages/admin/AnalyticsView';
import AccessCodesView from './pages/admin/AccessCodesView';
import AIUsageView from './pages/admin/AIUsageView';
import SpecialtyPromptsView from './pages/admin/SpecialtyPromptsView';
import AgentRunsView from './pages/admin/AgentRunsView';
import AIModelView from './pages/admin/AIModelView';

const queryClient = new QueryClient();

// Note: Fast refresh warning is expected for the main entry file
const App = () => {
  
  return (
    <QueryClientProvider client={queryClient}>
      <Router>
        <Switch>
          {/* Main app routes */}
          <Route path="/login" component={Login} />
          <Route path="/callback" component={Callback} />
          <Route path="/dashboard" component={Dashboard} />

          {/* Admin routes */}
          <Route path="/admin/login" component={AdminLogin} />
          <Route path="/admin/analytics" component={AnalyticsView} />
          <Route path="/admin/ai-usage" component={AIUsageView} />
          <Route path="/admin/access-codes" component={AccessCodesView} />
          <Route path="/admin/specialty-prompts" component={SpecialtyPromptsView} />
          <Route path="/admin/agent-runs" component={AgentRunsView} />
          <Route path="/admin/ai-model" component={AIModelView} />
          <Route path="/admin/conversation/:patientId/:sessionId" component={ConversationView} />
          <Route path="/admin" component={AdminDashboard} />

          {/* Default route */}
          <Route path="/" component={Login} />
        </Switch>
      </Router>
    </QueryClientProvider>
  );
};

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);